import React, { useEffect, useState } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  Button, VStack, Text, Box, HStack, Table, Thead, Tbody, Tr, Th, Td, Badge, Spinner,
} from '@chakra-ui/react';
import deportesApi, { Participacion, Deportista } from '../../../api/deportesApi';
import { ROJO, fmtFecha, nombreCompleto } from '../_shared';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  deportista: Deportista | null;
}

const ModalParticipaciones: React.FC<Props> = ({ isOpen, onClose, deportista }) => {
  const [data, setData] = useState<Participacion[]>([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    if (!isOpen || !deportista) return;
    setCargando(true);
    deportesApi
      .historialDeportista(deportista.id)
      .then((r) => setData(r || []))
      .catch(() => setData([]))
      .finally(() => setCargando(false));
  }, [isOpen, deportista]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader borderBottom="1px solid" borderColor="gray.200" color={ROJO}>
          Historial de participación — {deportista ? nombreCompleto(deportista) : ''}
        </ModalHeader>
        <ModalBody py={5}>
          {cargando ? (
            <VStack py={8}><Spinner color={ROJO} /><Text color="gray.500" fontSize="sm">Cargando historial...</Text></VStack>
          ) : data.length === 0 ? (
            <Box py={8} textAlign="center"><Text color="gray.400">Este deportista aún no tiene participaciones registradas</Text></Box>
          ) : (
            <Box overflowX="auto">
              <Table variant="simple" size="sm">
                <Thead bg={ROJO}>
                  <Tr>
                    <Th color="white" fontSize="xs">Torneo</Th>
                    <Th color="white" fontSize="xs">Disciplina</Th>
                    <Th color="white" fontSize="xs">Equipo</Th>
                    <Th color="white" fontSize="xs">Fecha</Th>
                    <Th color="white" fontSize="xs">Logros</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.map((p, idx) => (
                    <Tr key={p.id} bg={idx % 2 === 0 ? 'white' : 'gray.50'}>
                      <Td>
                        <Text fontSize="sm" fontWeight="medium">{p.torneo?.nombre || `Torneo #${p.torneoId}`}</Text>
                        {p.torneo?.estatus && <Badge fontSize="2xs" colorScheme="cyan">{p.torneo.estatus}</Badge>}
                      </Td>
                      <Td fontSize="sm">{p.torneo?.disciplina?.nombre || '—'}</Td>
                      <Td fontSize="sm">{p.equipo?.nombre || '—'}</Td>
                      <Td fontSize="sm">{fmtFecha(p.fecha || p.torneo?.fechaInicio)}</Td>
                      <Td fontSize="sm" maxW="220px"><Text noOfLines={2}>{p.logros || '—'}</Text></Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Cerrar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalParticipaciones;
